import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const AppContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '540px',
  margin: '0 auto',
  position: 'relative',
  minHeight: '100vh',
  
  [`@media (min-width: ${theme.breakpoints.values.lg}px)`]: {
    maxHeight: '100vh',
  },
}));

